export default __webpack_public_path__ + "static/media/feather-menu-close.0f7cc161.svg";